/**
 * [pug template]
 */
<template lang="pug">
  div
    .gallery(v-if="selectedImage")
      .image-gallery
        image-component(:src="selectedImage", :mouseEnter="enterOnImage", :mouseMove="moveOnImage", :mouseLeave="leaveOnImage", :onClick="toggleZoom")
        zoom-area(:isDisplayed="displayZoom", :image="selectedImage", :onClick="toggleZoom", :firstPosition="positionOnImage")
      .image-list-gallery
        image-radio-list(name="gallery-list", :options="list", :defaultField="selectedIndex" v-on:value-changed="imageChanged")
</template>
/**
 * [javascript application]
 */
<script>
import clientConfig from '../../config/global'
import { GalleryComputed, GalleryMethods, GalleryWatch } from '../../lib/inherited/gallery'
import { RenderingUnitComputed, RenderingUnitMethods, RenderingUnitWatch } from '../../lib/inherited/rendering_unit.js'

export default {
  name: 'gallery',
  props: {
    imageList: {
      type: Array,
      default: []
    },
    selectedImage: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      selectedIndex: 0,
      list: [],
      displayZoom: false,
      components: clientConfig.components,
      positionOnImage: { x: 0, y: 0 }// Utilisé par Edge pour éviter le zoom cassé et le clignotement
    }
  },
  created: function () {
    GalleryWatch.imageList(this.imageList, this.imageList)
  },
  components: clientConfig.components,
  computed: Object.assign({}, RenderingUnitComputed, GalleryComputed),
  methods: Object.assign({}, RenderingUnitMethods, GalleryMethods, {}),
  watch: Object.assign({}, RenderingUnitWatch, GalleryWatch)
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// Gallery.vue?05304adc